module.exports = __webpack_public_path__ + "img/taxDeductible.798ba97a.png";